import {Link} from "react-router-dom";
import Icon from "../../../components/selfcare/Icon";
import SelfcarePageContent from "../../../components/selfcare/SelfcarePageContent";
import {useCustomer} from "../../../layouts/SelfcareLayout";
import {formatCardExpiration} from "../../../util/formatter";
import Routing from "../../../Routing.ts";
import IconVisa from "../../../components/icons/IconVisa.tsx";
import IconVisaElectron from "../../../components/icons/IconVisaElectron.tsx";
import IconMastercard from "../../../components/icons/IconMastercard.tsx";
import IconDankort from "../../../components/icons/IconDankort.tsx";
import IconCreditcard from "../../../components/icons/IconCreditcard.tsx";
import setTitleAndMetaDescription from "../../../components/setTitleAndMetaDescription.tsx";

export default function CardPage() {
    setTitleAndMetaDescription("Betaling - Mit Hiper", "Her kan du se hvilken betalingsmetode der er tilknyttet dit abonnement, samt opdatere den.");

    const {customer: {customer_context: {finances}}} = useCustomer();

    return <SelfcarePageContent>
        <div className="selfcare-page-summary">
            <h1 className="heading heading--big">Betalingskort</h1>
            <p>
                Har du flere abonnementer, skal du tilføje kortet på dem alle.
            </p>
            <p>
                Har du en ubetalt regning, forsøger vi automatisk at trække beløbet, når du har tilføjet et kort.
            </p>
        </div>

        <div className={"selfcare-card-container"}>
            {finances.has_card && finances.card &&
                <div className={"selfcare-card"}>
                    <CreditCardIcon icon={finances.card.brand}/>
                    <div>
                        <p>
                            <span className={"label"}>Kortnummer:</span>
                            <span
                                className={"bullets"}>&bull;&bull;&bull;&bull;&nbsp;&bull;&bull;&bull;&bull;&nbsp;&bull;&bull;&bull;&bull;&nbsp;</span>{finances.card.last_four_digits}
                        </p>
                        <p>
                            <span className={"label"}>Udløber:</span>
                            {formatCardExpiration(finances.card.expiration)}
                        </p>
                    </div>
                </div>
            }
            {!finances.is_paying_overdue_invoices &&
                <Link to={Routing.Selfcare.AddCard} className={finances.has_card ? 'change-card' : 'add-card'} rel="nofollow">
                    {finances.has_card ? 'Skift betalingskort' : 'Tilføj et kort'}
                </Link>
            }
        </div>
    </SelfcarePageContent>
}

function CreditCardIcon({icon}: { icon: string }) {
    switch (icon) {
        case 'visa':
            return <Icon component={IconVisa}/>
        case 'visa-electron':
            return <Icon component={IconVisaElectron}/>
        case 'mastercard':
            return <Icon component={IconMastercard}/>
        case 'mastercard-debet':
            return <Icon component={IconMastercard}/>
        case 'dankort':
            return <Icon component={IconDankort}/>
        default:
            return <Icon component={IconCreditcard}/>
    }
}
